import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './AdminPopupPage.module.scss';
import commonStyles from '../AdminOrdersPage/AdminOrdersPage.module.scss';
import { toast } from 'react-toastify';
import { IoSaveOutline, IoCloudUploadOutline, IoTrashOutline, IoAddCircleOutline, IoCreateOutline } from 'react-icons/io5';

const API_URL = 'https://huongtramcomoc.vn/api/admin/popup_crud.php';
const BACKEND_URL = 'https://huongtramcomoc.vn';

const AdminPopupPage = () => {
  const [popups, setPopups] = useState([]);
  const [loading, setLoading] = useState(false);

  // Form State
  const [editingId, setEditingId] = useState(null); // null = Thêm mới
  const [isActive, setIsActive] = useState(true);
  const [linkUrl, setLinkUrl] = useState('');
  const [maxWidth, setMaxWidth] = useState(500); // Mặc định 500px
  const [imageUrl, setImageUrl] = useState('');
  const [file, setFile] = useState(null);

  useEffect(() => {
    loadPopups();
  }, []);

  const loadPopups = () => {
    axios.get(API_URL).then(res => setPopups(res.data || []));
  };

  const resetForm = () => {
    setEditingId(null);
    setIsActive(true);
    setLinkUrl('');
    setMaxWidth(500);
    setImageUrl('');
    setFile(null);
  };

  const handleEdit = (popup) => {
    setEditingId(popup.id);
    setIsActive(popup.is_active == 1);
    setLinkUrl(popup.link_url || '');
    setMaxWidth(popup.max_width || 500);
    setImageUrl(popup.image_url || '');
    setFile(null);
    window.scrollTo(0, 0);
  };

  const handleDelete = async (id) => {
    if(!window.confirm("Bạn chắc chắn muốn xóa Popup này?")) return;
    try {
        const formData = new FormData();
        formData.append('id', id);
        await axios.post(`${API_URL}?action=delete`, formData);
        toast.success("Đã xóa popup");
        loadPopups();
    } catch (e) { toast.error("Lỗi xóa"); }
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
      setImageUrl(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleSave = async () => {
    setLoading(true);
    const formData = new FormData();
    if (editingId) formData.append('id', editingId);
    
    formData.append('is_active', isActive ? 1 : 0);
    formData.append('link_url', linkUrl);
    formData.append('max_width', maxWidth);
    formData.append('current_image', imageUrl.replace(BACKEND_URL, '').replace('blob:', ''));
    
    if (file) formData.append('image', file);

    try {
      await axios.post(API_URL, formData);
      toast.success(editingId ? "Cập nhật thành công!" : "Thêm mới thành công!");
      loadPopups();
      resetForm();
    } catch (err) {
      toast.error("Lỗi khi lưu.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={commonStyles.adminPage}>
      <h1>Quản Lý Danh Sách Popup</h1>

      <div className={styles.layoutGrid}>
        
        {/* --- CỘT TRÁI: FORM NHẬP LIỆU --- */}
        <div className={styles.formCard}>
          <h2>{editingId ? `Chỉnh sửa #${editingId}` : 'Thêm Popup Mới'}</h2>
          
          <div className={styles.switchGroup}>
            <label className={styles.switch}>
              <input type="checkbox" checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
              <span className={styles.slider}></span>
            </label>
            <span>{isActive ? 'ĐANG BẬT' : 'ĐANG TẮT'}</span>
          </div>

          <div className={styles.formGroup}>
             <label>Ảnh Popup:</label>
             <div className={styles.imagePreview}>
               {imageUrl ? <img src={file ? imageUrl : `${BACKEND_URL}${imageUrl}`} alt="Preview" /> : <div className={styles.placeholder}>Chưa có ảnh</div>}
             </div>
             <input type="file" id="p_file" hidden onChange={handleFileChange} />
             <label htmlFor="p_file" className={styles.uploadBtn}><IoCloudUploadOutline /> Chọn ảnh</label>
          </div>

          <div className={styles.formGroup}>
            <label>Độ rộng tối đa (px):</label>
            <input type="number" value={maxWidth} onChange={(e) => setMaxWidth(e.target.value)} placeholder="VD: 500" />
            <small>Điện thoại sẽ tự động thu nhỏ nếu màn hình bé hơn số này.</small>
          </div>

          <div className={styles.formGroup}>
            <label>Link liên kết (Tùy chọn):</label>
            <input type="text" value={linkUrl} onChange={(e) => setLinkUrl(e.target.value)} placeholder="/san-pham/..." />
          </div>

          <div className={styles.btnRow}>
             {editingId && <button onClick={resetForm} className={styles.cancelBtn}>Hủy</button>}
             <button onClick={handleSave} className={styles.saveBtn} disabled={loading}>
                <IoSaveOutline /> {loading ? 'Đang lưu...' : (editingId ? 'Cập Nhật' : 'Thêm Mới')}
             </button>
          </div>
        </div>

        {/* --- CỘT PHẢI: DANH SÁCH --- */}
        <div className={styles.listCard}>
            <div className={styles.listHeader}>
                <h2>Danh Sách ({popups.length})</h2>
                <button onClick={resetForm}><IoAddCircleOutline /> Tạo mới</button>
            </div>
            
            <div className={styles.popupList}>
                {popups.map(p => (
                    <div key={p.id} className={`${styles.popupItem} ${p.is_active == 1 ? styles.activeItem : ''}`}>
                        <img src={`${BACKEND_URL}${p.image_url}`} alt="" />
                        <div className={styles.itemInfo}>
                            <strong>ID: {p.id} - {p.is_active == 1 ? <span style={{color:'green'}}>Đang chạy</span> : <span style={{color:'gray'}}>Đã tắt</span>}</strong>
                            <p>Max-width: {p.max_width}px</p>
                            <p className={styles.linkText}>{p.link_url || 'Không có link'}</p>
                        </div>
                        <div className={styles.itemActions}>
                            <button onClick={() => handleEdit(p)} className={styles.editBtn}><IoCreateOutline /></button>
                            <button onClick={() => handleDelete(p.id)} className={styles.delBtn}><IoTrashOutline /></button>
                        </div>
                    </div>
                ))}
            </div>
        </div>

      </div>
    </div>
  );
};
export default AdminPopupPage;